import { Transition } from '@headlessui/react';
import { Fragment, useContext } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { ControlContext } from 'provider/ControlProvider';
import CartField from 'components/CartField';
import CommonButton from 'components/CommonButton';
import { useMutation } from '@apollo/client';
import { CREATE_CHECKOUT } from 'graphql/checkout';
import PulseLoader from 'react-spinners/PulseLoader';
import Background from 'assets/img/stroypanel.jpg';

export default function CartPanel() {
  const { showModal, setShowModal, cart, setCart, priceArray, setPriceArray } =
    useContext(ControlContext);
  const [CreateCheckout, { loading }] = useMutation(CREATE_CHECKOUT);

  const onClear = () => {
    localStorage.setItem('Cart', '[]');
    setCart([]);
    setPriceArray([]);
    setShowModal(0);
  };

  const onSubmit = async () => {
    try {
      const data = cart.filter((ele) => ele.quantity !== 0);
      const variables = {
        input: {
          lineItems: data.map((ele) => ({
            variantId: ele.variantId,
            quantity: ele.quantity,
          })),
        },
      };
      const response = await CreateCheckout({ variables });
      window.open(response.data.checkoutCreate.checkout.webUrl, '_blank');
      onClear();
      // handle response
    } catch (error) {
      console.error(error);
    }
  };

  function closeModal() {
    setShowModal(0);
  }
  return (
    <Transition
      appear
      show={showModal === 4}
      as={Fragment}
      enter='transition-opacity duration-300'
      enterFrom='opacity-0'
      enterTo='opacity-100'
      leave='transition-opacity duration-150'
      leaveFrom='opacity-100'
      leaveTo='opacity-0'
    >
      <div
        className='w-full md:w-96 absolute border-t-12 border-l-0 border-r-0 md:border-l-12 md:border-r-12 border-b-0 md:border-b-12 border-opacity-80 border-yellow-900 rounded-t-3xl rounded-b-none md:rounded-b-3xl text-lg bottom-0 md:top-28 left-0 md:left-12 h-1/4 md:h-5/6 p-5 overflow-hidden shadow-lg drop-shadow-lg stroy-panel bg-cover bg-no-repeat bg-center'
        style={{ backgroundImage: `url(${Background})` }}
      >
        <div className='flex justify-between items-center mb-2'>
          <h1 className='text-zinc-900 text-3xl'>Your Bag</h1>
          <button onClick={() => closeModal()}>
            <XMarkIcon className='w-8' />
          </button>
        </div>
        <Scrollbars className='w-full h-full'>
          <div className='mt-8 flex flex-col mr-6'>
            <div className='-my-2 -mx-4 sm:-mx-6 lg:-mx-8'>
              <div className='inline-block min-w-full py-2 align-middle md:px-6 lg:px-8'>
                <div className='flex  justify-between text-sm mb-2 text-center'>
                  <p className='w-1/2'>Name</p>
                  <p className='w-1/2'>Quantiy</p>
                  <p className='w-12'>Price</p>
                  <p className='w-6'></p>
                </div>
                {cart.map((ele, index) => (
                  <CartField
                    key={index}
                    id={ele.productId}
                    quantity={ele.quantity}
                    variantId={ele.variantId}
                  />
                ))}
                <div className='flex justify-between items-start border-t-2 border-zinc-600 px-4'>
                  <div className='whitespace-nowrap py-4 px-3 text-xl text-zinc-800'>
                    SubTotal:
                  </div>
                  <div className='whitespace-nowrap py-4 px-3 text-xl text-zinc-800'>
                    {priceArray.reduce((acc, curr) => acc + curr.quantity, 0)}$
                  </div>
                </div>
                <div className='flex justify-center my-7'>
                  <CommonButton
                    className='w-2/3'
                    onClick={(e) => {
                      e.preventDefault();
                      onSubmit();
                    }}
                  >
                    {loading ? (
                      <div className='flex justify-center items-center space-x-4'>
                        <p>Processing</p>
                        <PulseLoader size={6} color='#72A0F7' />
                      </div>
                    ) : (
                      <p>CheckOut</p>
                    )}
                  </CommonButton>
                </div>
              </div>
            </div>
          </div>
          <p className='mt-12'></p>
        </Scrollbars>
      </div>
    </Transition>
  );
}
